<form [formGroup]="feederForm">
  <div class="row">
    <div class="col-12 mb-2">
      <span>{{'tables.feeder' | translate}}</span>
      <input
        type="text"
        class="form-control"
        formControlName="name"
        [class.is-invalid]="
          feederForm.get('name')?.invalid &&
          feederForm.get('name')?.touched
        "
        placeholder="{{ 'feeder-form.feeder-name-placeholder' | translate }}"
      />
      <span
        class="text-danger"
        *ngIf="
          feederForm.get('name')?.invalid &&
          feederForm.get('name')?.touched
        "
      >
        {{ "admin.admins.error-name" | translate }}
      </span>
    </div>
    <div class="col-12 mb-2">
      <span>Mac Address</span>
      <input
        type="text"
        class="form-control"
        formControlName="mac"
        [class.is-invalid]="
          feederForm.get('mac')?.invalid &&
          feederForm.get('mac')?.touched
        "
        placeholder="00:00:00:00:00:00:00:00"
      />
      <span
        class="text-danger"
        *ngIf="
          feederForm.get('mac')?.invalid &&
          feederForm.get('mac')?.touched &&
          feederForm.get('mac')?.errors?.required
        "
      >
        {{ "feeder-form.mac-address-required" | translate }}
      </span>
      <span
        class="text-danger"
        *ngIf="feederForm.controls['mac'].errors?.pattern && feederForm.get('mac')?.touched"
      >
        {{'feeder.invalid' | translate}}
      </span>
    </div>
    <div class="col-12 mb-2">
      <span>{{'feeder.series-number' | translate}}</span>
      <input
        type="text"
        class="form-control"
        formControlName="series"
        [class.is-invalid]="
          feederForm.get('series')?.invalid &&
          feederForm.get('series')?.touched
        "
        placeholder="{{ 'feeder-form.serial-number-placeholder' | translate }}"
      />
      <span
        class="text-danger"
        *ngIf="
          feederForm.get('series')?.invalid &&
          feederForm.get('series')?.touched
        "
      >
        {{ "feeder-form.serial-number-required" | translate }}
      </span>
    </div>

    <div class="col-12 mb-2">
      <span>{{'alerts.general.dispenser' | translate}}</span>
      <app-spinner [smallLoader]="true" *ngIf="loadingDispensers"></app-spinner>
      <select
        class="form-control"
        formControlName="dispenser"
        [class.is-invalid]="
          feederForm.get('dispenser')?.invalid &&
          feederForm.get('dispenser')?.touched
        "
      >
        <option value="">{{'feeder.select-dispenser' | translate}}</option>
        <option *ngFor="let item of dispensers" [value]="item.id">{{item.name}}</option>
      </select>
      <span
        class="text-danger"
        *ngIf="
          feederForm.get('dispenser')?.invalid &&
          feederForm.get('dispenser')?.touched
        "
      >
        {{ "feeder-form.dispenser-required" | translate }}
      </span>
    </div>
    <div class="col-12 mb-2">
      <span>{{'tables.brand' | translate}}</span>
      <app-spinner [smallLoader]="true" *ngIf="loadingBrands"></app-spinner>
      <select
        class="form-control"
        formControlName="brand"
        [class.is-invalid]="
          feederForm.get('brand')?.invalid &&
          feederForm.get('brand')?.touched
        "
      >
        <option value="">{{'feeder.select-brand' | translate}}</option>
        <option *ngFor="let item of brands" [value]="item.id">{{item.name}}</option>
      </select>
      <span
        class="text-danger"
        *ngIf="
          feederForm.get('brand')?.invalid &&
          feederForm.get('brand')?.touched
        "
      >
        {{ "admin.food.brand-required" | translate }}
      </span>
    </div>
    <div class="col-12 col-md-6 mb-2">
      <span>{{ "update-device-dynamic.warranty-months" | translate }}</span>
      <input
        type="number"
        class="form-control"
        formControlName="warranty_months"
        min="0"
        [placeholder]="'update-device-dynamic.warranty-months-placeholder' | translate"
      />
    </div>
    <div class="col-12 col-md-6 mb-2">
      <span>{{ "update-device-dynamic.warranty-start-date" | translate }}</span>
      <input
        type="date"
        class="form-control"
        formControlName="warranty_start_date"
      />
    </div>
    <div class="col-12 mb-2" *ngIf="storageService.isAdmin()">
      <span>{{'tables.client' | translate}}</span>
      <app-spinner [smallLoader]="true" *ngIf="loadingClients"></app-spinner>
      <ng-container *ngIf="!loadingClients">
        <div>
          <input
            type="text"
            class="form-control"
            formControlName="filteredBusinessName"
            (keyup)="filterClientsList()"
          />
        </div>

        <select
          class="form-control mt-2"
          formControlName="client"
          (change)="getFarms($event.target.value)"
          name="client"
          id="client"
        >
          <option value="">{{'admin.admins.select-client' | translate}}</option>
          <option *ngFor="let item of filteredClients" [value]="item.id">{{ item.name }}</option>
        </select>
      </ng-container>
    </div>
  </div>
</form>

<form [formGroup]="selectFarms" (submit)="register(feederForm.value)">
  <div class="row">
    <div class="col-12 mb-2">
      <span>{{'general.farm' | translate}}</span>
      <app-spinner [smallLoader]="true" *ngIf="loadingFarms"></app-spinner>
      <select
        class="form-control"
        *ngIf="farms.length > 0 && !loadingFarms"
        formControlName="farm"
        (change)="getPonds($event.target.value)"
        [class.is-invalid]="
          selectFarms.get('farm')?.invalid &&
          selectFarms.get('farm')?.touched
        "
      >
        <option value="">{{'feeder.select-farm' | translate}}</option>
        <option *ngFor="let item of farms" [value]="item.id">{{item.name}}</option>
      </select>
      <span
        class="text-danger"
        *ngIf="
          selectFarms.get('farm')?.invalid &&
          selectFarms.get('farm')?.touched
        "
      >
        {{ "feeder-form.farm-required" | translate }}
      </span>
      <p *ngIf="farms.length === 0">{{'feeder.no-farms' | translate}}</p>
    </div>
    <div class="col-12 mb-2" *ngIf="!storageService.isAdmin()">
      <span>{{'tables.ponds' | translate}}</span>
      <app-spinner [smallLoader]="true" *ngIf="loadingPonds"></app-spinner>
      <select
        class="form-control"
        *ngIf="ponds.length > 0"
        formControlName="pond"
        [class.is-invalid]="
          selectFarms.get('pond')?.invalid &&
          selectFarms.get('pond')?.touched
        "
      >
        <option value="">{{'general.select-pond' | translate}}</option>
        <option *ngFor="let item of ponds" [value]="item.id">{{item.name}}</option>
      </select>
      <span
        class="text-danger"
        *ngIf="
          selectFarms.get('pond')?.invalid &&
          selectFarms.get('pond')?.touched
        "
      >
        {{ "clients.cycles.assign-cycle.pond-required" | translate }}
      </span>
      <p *ngIf="ponds.length === 0">{{'feeder.no-ponds' | translate}}</p>
    </div>
  </div>
</form>
<div class="center mt-3 w-100">
  <button class="btn btn-success btn-space" type="submit" (click)="register(feederForm.value)">
    {{'general.finish' | translate}}
  </button>
</div>
